import moment from "moment";
import { ClusterKey } from "src/app/ui/models/domains/pbm/clusters/cluster-key.model";
import { ClusterProduct } from "src/app/ui/models/domains/pbm/clusters/cluster-product.model";
import { Cluster } from "src/app/ui/models/domains/pbm/clusters/cluster.model";
import { IndustryProductEan } from "src/app/ui/models/domains/pbm/industry/industry-product-discounts.model";

export function parseClusters(payload: any): Cluster[] {
  return payload.map((item) => {
    return new Cluster(
      parseClusterKey(item.ClusterKey),
      item.Name,
      item.TotalProducts,
      moment(item.CreateDate).format("DD/MM/YYYY"),
      moment(item.LastChangeDate).format("DD/MM/YYYY"),
      payload.Data,
    );
  });
}

export function parseCluster(payload: any): Cluster {
  return new Cluster(
    parseClusterKey(payload.ClusterKey),
    payload.Name,
    payload.TotalProducts,
    moment(payload.Created).format("DD/MM/YYYY"),
    moment(payload.LastChangeDate).format("DD/MM/YYYY"),
    parseClustersProducts(payload.Data),
  );
}

export function parseClustersProducts(payload: any): Array<ClusterProduct> {
  return payload.map((item) => {
    return new ClusterProduct(item.Id, item.Ean, item.Name);
  });
}

export function parseImportClustersResults(payload: any): Array<ClusterProduct> {
  return payload.map((item) => {
    return new ClusterProduct(item.Name, item.Mensssage, item.Ean);
  });
}

export function parseClusterKey(payload: any): ClusterKey {
  return new ClusterKey(payload.Value);
}

export function parseIndustryProductEan(payload: any): IndustryProductEan {
  return new IndustryProductEan(payload.Value);
}
